import styled from "styled-components"

export const StyledCareerJobBackButton = styled.div`
  display: flex;
  margin: 0 0 4.8rem 0;
`

export const StyledCareerJobHeaders = styled.div`
  display: flex;
  display: -moz-flex;
  -moz-align-items: center;
  align-items: center;

  @media (max-width: 767px) {
    display: block;
  }
`

export const StyledHeaderItem = styled.div`
  display: flex;
  margin: 2.4rem 2.4rem 0 0;
  align-item: center;

  p {
    padding: 3px 10px;
    font-weight: 700;
    color: black;
  }
`

export const StyledCareerJobBtn = styled.div`
  display: flex;
`